/**
 * Appends an parameter with paramName to a provided url.
 */
export const addParamToURL = (url, paramName, paramValue) => {
  const redirectUrl = new URL(url);
  redirectUrl.searchParams.append(paramName, paramValue);
  return redirectUrl;
};
